import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SecurityService } from '~/services/security.service';

@Component({
    selector: 'app-auth-base',
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AuthBase {

  licenses: any;

  constructor(protected _securityService: SecurityService) {
  }


}
